const d =
	'M480-634Zm154 154Zm-307 0Zm153 153Zm0-224L369-663v-217h223v217L480-551Zm183 182L551-480l112-112h217v223H663Zm-583 0v-223h217l112 112-112 111H80ZM369-80v-217l111-112 112 112v217H369Zm111-554 52-52v-134H429v134l51 52ZM140-429h135l52-51-52-52H140v103Zm289 289h103v-135l-52-52-51 52v135Zm257-289h134v-103H686l-52 52 52 51Z';

export default d;
